// Entry point for the build script in your package.json

require("@rails/ujs").start()
require("@rails/activestorage").start()

import "./jquery"
import "./jquery-ui"
import "./jquery.ui.touch-punch"

import "./admin/location_plans.js"
import "./admin/insurer_templates.js"
import "./jSignature.min.js"
import "./credit_cards.js"
import "./user_profiles.js"
import "./covid_test_claim_submissions.js"
import "./camera.js"
import "./files.js"
import "./user_insurance_information.js"
import "./user_insurance_information_members.js"
import "./users.js"
import "./controllers"
import { Turbo } from "@hotwired/turbo-rails"
import { registerTurboStreamRedirect } from "./lib/turbo_stream_redirect.mjs"

// Custom Turbo Stream action: redirect
// Usage from Rails: turbo_stream.action(:redirect, some_path)
registerTurboStreamRedirect(Turbo)
import "./forms.js"
import "./check_for_bad_urls.js"
import { spinnerCycler } from "./spinner_cycler"

import LocalTime from "local-time"
LocalTime.start()

// After a Turbo page change, ensure we have the latest CSRF token on all forms.
// https://stackoverflow.com/questions/55040734/csrf-token-error-occurs-when-using-turbolinks-with-ruby-on-rails
import Rails from "@rails/ujs"
document.addEventListener("turbo:load", () => {
  console.log('[application.js] turbo:load event fired')
  Rails.refreshCSRFTokens();
  // Clean up disconnected spinners and initialize spinner cycling for any spinners on the page
  spinnerCycler.cleanupDisconnectedElements()
  spinnerCycler.initializeSpinners();
});

// Load analytics as the last step, so it doesn't interfere with Turbo's handling of links/forms.
if (typeof (initInspectlet) !== "undefined") {
  initInspectlet();
}
if (typeof (initHeap) !== "undefined") {
  initHeap();
}
